import { LoadMode } from "./index49.js";
import { Side } from "./index50.js";
const mainLoadOptions = {
	[LoadMode.dynamic]: [
		void 0,
		Side.left,
		Side.right
	],
	[LoadMode.double]: [void 0],
	[LoadMode.single]: [Side.left]
};
export { mainLoadOptions };

//# sourceMappingURL=index53.js.map